import { visserApi } from "./visserApi";
const getAllEmployeeHourType = async () => {
    return await visserApi.get('EmployeeHourType/GetAll');
};
const createEmployeeHourType = async (createdEmployeeHourType) => {
    return await visserApi.post('EmployeeHourType/Create', createdEmployeeHourType);
};
const updateEmployeeHourType = async (updateEmployeeHourType) => {
    return await visserApi.put('EmployeeHourType/Update', updateEmployeeHourType);
};
const getEmployeeHourTypeById = async (employeeHourTypeId) => {
    return await visserApi.get(`EmployeeHourType/GetById/${employeeHourTypeId}`);
};
const employeeHourTypeApi = {
    getAllEmployeeHourType,
    createEmployeeHourType,
    updateEmployeeHourType,
    getEmployeeHourTypeById
};
export default employeeHourTypeApi;
